__turbopack_context__.v({
  "creditGetEasy": "CreditGetEasy-module-scss-module__jQsIRq__creditGetEasy",
  "creditGetEasy__content": "CreditGetEasy-module-scss-module__jQsIRq__creditGetEasy__content",
  "creditGetEasy__title": "CreditGetEasy-module-scss-module__jQsIRq__creditGetEasy__title",
});
